import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { SolutionBenefits } from './components/SolutionBenefits';
import { ProductShowcase } from './components/ProductShowcase';
import { TransformationSection } from './components/TransformationSection';
import { AboutCreator } from './components/AboutCreator';
import { MidPagePricing } from './components/MidPagePricing';
import { BundleDetails } from './components/BundleDetails';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  useEffect(() => {
    // Script 1: UTMify UTMs tracking
    const utmScript = document.createElement('script');
    utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmScript.setAttribute('data-utmify-prevent-subids', '');
    utmScript.async = true;
    utmScript.defer = true;
    document.head.appendChild(utmScript)
    // Script 2: UTMify Pixel tracking
    ;
    (window as any).pixelId = '69744866af48a876a5c28040';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    return () => {
      document.head.removeChild(utmScript);
      document.head.removeChild(pixelScript);
    };
  }, []);
  return <main className="min-h-screen w-full bg-white font-sans text-text-dark selection:bg-terracotta/20" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SocialProof data-id="element-2" />
      <PainPoints data-id="element-3" />
      <SolutionBenefits data-id="element-4" />
      <ProductShowcase data-id="element-5" />
      <TransformationSection data-id="element-6" />
      <AboutCreator data-id="element-7" />
      <MidPagePricing data-id="element-8" />
      <BundleDetails data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />

      {/* Footer */}
      <footer className="bg-text-dark py-8 text-center text-white/60" data-id="element-12">
        <p className="text-sm" data-id="element-13">
          © {new Date().getFullYear()} The Peaceful Dinner Protocol. All rights
          reserved.
        </p>
      </footer>
    </main>;
}